
  export default {
    middleware: ['products/cover-types', 'searches/life-insurance', 'products/life-insurance-plan', 'breadcrumbs', 'jumbotron', 'meta-tags'],
    meta: {
      breadcrumbs: [['i18n/home', '/'], ['i18n/insurance', '/insurance/']],
      category: 'insurance',
      metaTagOptions: { image: 'insurance' }
    },
    computed: {
      dayOfTheWeek () {
        return new Date().getDay();
      },
      hourOfTheDay () {
        return new Date().getHours();
      },
      plan () {
        return this.$store.getters['products/get'];
      },
      showCTA () {
        return (this.dayOfTheWeek >= 1 && this.dayOfTheWeek <= 5) && (this.hourOfTheDay >= 9 && this.hourOfTheDay < 17);
      }
    }
  };
